import React from 'react';
import './titleContainer2.less';
import { TitleAppearance } from './types';

export interface TitleContainer2Props {
	text?: string;
	subtitle?: string;
	/** Custom css class names */
	cssClassName?: string;
	content?: () => React.ReactNode;
	hasGrayBackground?: boolean;
	controlPanel?: () => React.ReactNode;
	titleAppearance?: TitleAppearance;
}

export const TitleContainer2: React.FC<TitleContainer2Props> = (
	props: React.PropsWithChildren<TitleContainer2Props>
) => {
	const { text, subtitle, content, hasGrayBackground, controlPanel, children, titleAppearance, cssClassName } = props;

	const titleCssClass = `ds-title${titleAppearance ? ' title-appearance-' + titleAppearance : ''}`;

	return (
		<div className={`it-title-container${cssClassName ? ' ' + cssClassName : ''}`}>
			{text && (
				<div className={`title-container ${hasGrayBackground ? 'grayBackground' : ''}`}>
					<div>
						<span className={titleCssClass}>{text}</span>
						{subtitle && <span className="ds-subtitle">{subtitle}</span>}
					</div>
					{controlPanel && controlPanel()}
				</div>
			)}
			<>
				{content && content()}
				{children}
			</>
		</div>
	);
};
